module.exports = __webpack_public_path__ + "static/media/Napranum.5d4ded91.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Napranum.jpeg
// module id = 647
// module chunks = 0